<!--============================
=            HOVERS            =
=============================-->
<template>
  <!-- HOVER CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Hover</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Playground Hover
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-4 transparent">
              <v-row class="pa-5">
                <v-col cols="12" sm="6" offset-sm="3">
                  <v-hover
                    v-slot:default="{ hover }"
                    :open-delay="openDelay"
                    :close-delay="closeDelay"
                    :disabled="disabled"
                    :value="value"
                  >
                    <v-card
                      :elevation="hover ? 12 : 2"
                      height="300"
                      max-width="350"
                      class="mx-auto"
                    >
                      <v-card-text class="my-4 text-center title">Hover over me!</v-card-text>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>

              <v-row align="center" justify="center">
                <v-col cols="12" md="6">
                  <v-radio-group row>
                    <v-checkbox v-model="disabled" label="Disabled" class="mx-2"></v-checkbox>
                    <v-checkbox v-model="value" label="Value" class="mx-2"></v-checkbox>
                  </v-radio-group>

                  <v-slider v-model="openDelay" label="Open Delay" min="0" max="1000" thumb-label></v-slider>

                  <v-slider v-model="closeDelay" label="Close Delay" min="0" max="1000" thumb-label></v-slider>
                </v-col>
              </v-row>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Disabled
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row align="center" class="pa-5" justify="center">
              <v-col cols="12">
                <v-hover v-slot:default="{ hover }" disabled>
                  <v-card :elevation="hover ? 12 : 2" class="mx-auto" height="350" max-width="350">
                    <v-card-text class="my-4 text-center title">Hover over me!</v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Open/Close Delay
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row class="pa-5">
              <v-col cols="12" sm="6">
                <v-hover v-slot:default="{ hover }" open-delay="200">
                  <v-card :elevation="hover ? 16 : 2" class="mx-auto" height="350" max-width="350">
                    <v-card-text
                      class="font-weight-medium mt-12 text-center subtitle-1"
                    >Open Delay (Mouse enter)</v-card-text>
                  </v-card>
                </v-hover>
              </v-col>

              <v-col cols="12" sm="6">
                <v-hover v-slot:default="{ hover }" close-delay="200">
                  <v-card :elevation="hover ? 16 : 2" class="mx-auto" height="350" max-width="350">
                    <v-card-text
                      class="font-weight-medium mt-12 text-center subtitle-1"
                    >Close Delay (Mouse leave)</v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Hover list
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="pa-4 text-center">
              <v-row class="fill-height" align="center" justify="center">
                <template v-for="(item, i) in items">
                  <v-col :key="i" cols="12" md="4" sm="12">
                    <v-hover v-slot:default="{ hover }">
                      <v-card :elevation="hover ? 12 : 2" pa-5 :class="{ 'on-hover': hover }">
                        <img :src="item.img" height="225px" />
                        <v-card-title class="title white--text">
                          <v-row class="fill-height flex-column" justify="space-between">
                            <p class="mt-4 subheading text-left">{{ item.title }}</p>

                            <div>
                              <p
                                class="ma-0 body-1 font-weight-bold font-italic text-left"
                              >{{ item.text }}</p>
                              <p
                                class="caption font-weight-medium font-italic text-left"
                              >{{ item.subtext }}</p>
                            </div>

                            <div class="align-self-center">
                              <v-btn
                                v-for="(icon, index) in icons"
                                :key="index"
                                :class="{ 'show-btns': hover }"
                                color="transparent"
                                icon
                              >
                                <v-icon
                                  :class="{ 'show-btns': hover }"
                                  color="transparent"
                                >{{ icon }}</v-icon>
                              </v-btn>
                            </div>
                          </v-row>
                        </v-card-title>
                      </v-card>
                    </v-hover>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <!-- HOVER  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Transitions
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-hover v-slot:default="{ hover }">
              <v-card class="pa-5 mx-auto" color="grey lighten-4" max-width="600">
                <img :aspect-ratio="16 / 9" src="../../assets/img/bg/1.jpg" />
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal display-3 white--text"
                    style="height: 100%;"
                  >$14.99</div>
                </v-expand-transition>

                <v-card-text class="pt-6" style="position: relative;">
                  <v-btn absolute color="orange" class="white--text" fab large right top>
                    <v-icon>mdi-cart</v-icon>
                  </v-btn>
                  <div class="font-weight-light grey--text title mb-2">For the perfect meal</div>
                  <h3 class="display-1 font-weight-light orange--text mb-2">QW cooking utensils</h3>
                  <div class="font-weight-light title mb-2">
                    Our Vintage kitchen utensils delight any chef.
                    <br />Made of bamboo by hand
                  </div>
                </v-card-text>
              </v-card>
            </v-hover>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    disabled: false,
    openDelay: "0",
    closeDelay: "0",
    value: false,
    icons: ["mdi-rewind", "mdi-play", "mdi-fast-forward"],
    items: [
      {
        title: "New Releases",
        text: "It's New Release Friday",
        subtext: "Newly released songs. Updated daily.",
        img: "http://lorempixel.com/output/nightlife-q-c-640-480-5.jpg"
      },
      {
        title: "Rock",
        text: "Greatest Rock Hits",
        subtext: "Lose yourself in rock tunes.",
        img:
          "https://images.unsplash.com/photo-1498038432885-c6f3f1b912ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80"
      },
      {
        title: "Mellow Moods",
        text: "Ambient Bass",
        subtext: "Chill beats to mellow you out.",
        img: "http://lorempixel.com/output/abstract-q-c-640-480-6.jpg"
      }
    ],
    transparent: "rgba(255, 255, 255, 0)"
  })
};
</script>

<style scoped>
.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>

<!--====  End of HOVERS  ====-->
